import { IFeatureMenuQuery } from 'generated/sanity-graphql';
import { useAuthContext } from 'state/auth';

import { useEmergencyBanner } from '../../emergency-banner/use-emergency-banner';
import { getUniqueComponents } from '../utils';

export const useFeatureMenuPageComponents = (
  featureMenuPage?: IFeatureMenuQuery['FeatureMenu']
) => {
  const { isAuthenticated } = useAuthContext();

  const isUserAuthenticated = isAuthenticated();

  const getFeatureMenuPageData = () => {
    if (isUserAuthenticated) {
      return featureMenuPage?.authenticated;
    }
    return featureMenuPage?.unauthenticated;
  };

  const featureMenuPageComponentMap = getUniqueComponents(getFeatureMenuPageData()?.components);
  const { emergencyBanner, emergencyBannerLoading } = useEmergencyBanner(
    featureMenuPageComponentMap.EmergencyBanner
  );

  const featureMenuPageComponentsLoading = emergencyBannerLoading;

  const allPopulatedComponents = [emergencyBanner];

  return {
    featureMenuPageComponentsLoading,
    featureMenuPageComponents: allPopulatedComponents,
  };
};
